var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0021 6.40789C19.3915 6.01853 19.3915 5.38725 19.0021 4.99789C18.6128 4.60853 17.9815 4.60853 17.5921 4.99789L12.7071 9.88289C12.3166 10.2734 11.6834 10.2734 11.2929 9.88289L6.40791 4.99789C6.01855 4.60853 5.38727 4.60853 4.99791 4.99789C4.60855 5.38725 4.60855 6.01853 4.99791 6.40789L9.88291 11.2929C10.2734 11.6834 10.2734 12.3166 9.88291 12.7071L4.99791 17.5921C4.60855 17.9815 4.60855 18.6127 4.99791 19.0021C5.38727 19.3915 6.01855 19.3915 6.40791 19.0021L11.2929 14.1171C11.6834 13.7266 12.3166 13.7266 12.7071 14.1171L17.5921 19.0021C17.9815 19.3915 18.6128 19.3915 19.0021 19.0021C19.3915 18.6127 19.3915 17.9815 19.0021 17.5921L14.1171 12.7071C13.7266 12.3166 13.7266 11.6834 14.1171 11.2929L19.0021 6.40789Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a28cb2e2ae1a34d0adef84677b06f908.svg";
export { ForwardRef as ReactComponent };